import styled from 'styled-components';

export const Container = styled.div`
  .content-layout__body {
    padding: 16px 16px 16px 16px;
  }
`;
